import { useEffect, useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const MagneticCard = ({ children, className = "", strength = 0.14 }) => {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 130, damping: 13, mass: 0.5 });
  const sy = useSpring(y, { stiffness: 130, damping: 13, mass: 0.5 });

  useEffect(() => {
    const onMove = (e) => {
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const offX = e.clientX - Math.max(r.left, Math.min(e.clientX, r.right));
      const offY = e.clientY - Math.max(r.top, Math.min(e.clientY, r.bottom));
      const dist = Math.hypot(offX, offY);
      if (dist <= 40) {
        x.set((e.clientX - (r.left + r.width / 2)) * strength);
        y.set((e.clientY - (r.top + r.height / 2)) * strength);
      } else {
        x.set(0);
        y.set(0);
      }
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, [strength, x, y]);

  return (
    <motion.div ref={ref} style={{ x: sx, y: sy }} className={`liquid-card h-full ${className}`}>
      {children}
    </motion.div>
  );
};
